const audios_data = [
    {
        image: "https://placehold.co/300x200?text=Selecciona+o+arrastra+tu+imagen",
        title: '',
        audio: null,
    },
    {
        image: "https://placehold.co/300x200?text=Selecciona+o+arrastra+tu+imagen",
        title: '',
        audio: null,
    },
    {
        image: "https://placehold.co/300x200?text=Selecciona+o+arrastra+tu+imagen",
        title: '',
        audio: null,
    },
]

const config = {
    type: 'MULTIMEDIA',
    component: "Smu04",
    portrait: "/img/container/S-MU-04.jpg",
    body: {
        title: '',
        audios: audios_data
    },
}

export { config }